var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[(_vm.images.length>0)?_c('div',{attrs:{"no-gutters":""}},[_c('Images',{attrs:{"images":_vm.images}})],1):_vm._e()])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }